import { type ITextComponentWithAssetsModel } from "@nf/common";
import { useTranslation } from "next-i18next";

import Accordion from "components/Accordion";
import Button from "components/Button";

import type { ILandingPageFaqComponent } from "../types";

import styles from "./LandingPageFAQ.module.scss";

type LandingPageFAQProps = {
  component: ITextComponentWithAssetsModel;
};

const LandingPageFAQ = ({ component }: LandingPageFAQProps) => {
  const { t } = useTranslation("translations");
  const { questions, footer } =
    component.TextParsed as unknown as ILandingPageFaqComponent;

  return (
    <div className={styles.container}>
      <Accordion
        items={questions.map((element) => ({
          id: element.title,
          title: element.title,
          content: (
            <>
              {element.description}{" "}
              {element.link && (
                <a href={element.link} className={styles.link}>
                  {t("web_landing_page_faq_read_more_text")}
                </a>
              )}
            </>
          ),
        }))}
      />

      <div className={styles.footer}>
        <span className={styles.footerText}>
          {t("web_landing_page_faq_additional_questions_text")}
        </span>

        <Button
          size="medium"
          variant="subtle"
          className={styles.footerAction}
          href={footer.link}
          target="_blank"
        >
          {t("web_landing_page_faq_helpcenter_text")}
        </Button>
      </div>
    </div>
  );
};

export default LandingPageFAQ;
